// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.landing-page-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  min-height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.landing-page-grid {
  display: flex;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.tile {
  width: 50%;
}

.image-card {
  display: block;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.6) 2px 2px 10px 3px;
}
  
.image-card:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out;
}

.tile-info-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.simple-tooltip {
  position: absolute;
  top: 100%;
  right: -140%;
  margin-top: 8px;
  z-index: 20;
  background-color: #000;
  color: #fff;
  font-size: 15px;
  font-family: "MBCorpoSText-Regular";
  line-height: 1.25rem;
  letter-spacing: 0.0125em;
  padding: 8px 10px;
  border-radius: 4px;
  max-width: 320px;
  min-width: 250px;
  text-align: left;
}

.simple-tooltip2 {
  position: absolute;
  top: 100%;
  right: -140%;
  margin-top: 8px;
  z-index: 20;
  background-color: #000;
  color: #fff;
  font-size: 15px;
  font-family: "MBCorpoSText-Regular";
  line-height: 1.25rem;
  letter-spacing: 0.0125em;
  padding: 8px 10px;
  border-radius: 4px;
  max-width: 320px;
  min-width: 250px;
  text-align: left;
}

.tile-text {
  font-family: "MBCorpoSTitle-Regular";
  font-size: 20px;
  line-height: 1.25rem;
  letter-spacing: 0.0125em;
  color: black;
}

.tile:hover {
  /* background: #494949; */
  /* border-radius: 2px solid red; */
}

.tile:hover .tile-text {
  /* color: #00adef; */
}

/* .tile:hover .tooltip {
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)
    brightness(120%) contrast(120%);
} */

.tooltip {
  filter: brightness(0.2);
}

.tooltip-icon {
  width: 25px;
  margin: 0 2px;
  cursor: pointer;
}

.tooltip:hover {
  filter: brightness(0.5) invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)
    brightness(120%) contrast(120%);
}

@media (max-width: 767px) {
  .landing-page-container {
    padding: 0 16px;
    min-height: 75vh;
  }

  .simple-tooltip {
    max-width: 240px;
  }

  .simple-tooltip2 {
    max-width: 240px;
  }

  .image-card {
    width: 60%;
  }
}

@media (max-width: 1024px) {
  .landing-page-container {
    min-height: 75vh;
  }

  .image-card {
    width: 50%;
  }
}

@media (max-width: 500px) {
  .landing-page-container {
    width: 95vw;
  }

  .landing-page-grid {
    flex-direction: column;
    gap: 50px;
    width: 100%;
  }

  .tile {
    width: 100%;
  }

  .tile-text {
    width: auto;
    word-wrap:break-word;
  }

  .simple-tooltip {
    left: 50%;
    transform: translateX(-82%);
  }

  .simple-tooltip2 {
    left: 20%;
    transform: translate(-75%);
  }
}

@media (max-height: 740px) {
  .landing-page-container {
    height: 90vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage/LandingPage.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;mCACiC;AACnC;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["\n.landing-page-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  box-sizing: border-box;\n  min-height: 75vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.landing-page-grid {\n  display: flex;\n  width: 100%;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.tile {\n  width: 50%;\n}\n\n.image-card {\n  display: block;\n  width: 50%;\n  margin-left: auto;\n  margin-right: auto;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.6) 2px 2px 10px 3px;\n}\n  \n.image-card:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease-in-out;\n}\n\n.tile-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tooltip-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.simple-tooltip {\n  position: absolute;\n  top: 100%;\n  right: -140%;\n  margin-top: 8px;\n  z-index: 20;\n  background-color: #000;\n  color: #fff;\n  font-size: 15px;\n  font-family: \"MBCorpoSText-Regular\";\n  line-height: 1.25rem;\n  letter-spacing: 0.0125em;\n  padding: 8px 10px;\n  border-radius: 4px;\n  max-width: 320px;\n  min-width: 250px;\n  text-align: left;\n}\n\n.simple-tooltip2 {\n  position: absolute;\n  top: 100%;\n  right: -140%;\n  margin-top: 8px;\n  z-index: 20;\n  background-color: #000;\n  color: #fff;\n  font-size: 15px;\n  font-family: \"MBCorpoSText-Regular\";\n  line-height: 1.25rem;\n  letter-spacing: 0.0125em;\n  padding: 8px 10px;\n  border-radius: 4px;\n  max-width: 320px;\n  min-width: 250px;\n  text-align: left;\n}\n\n.tile-text {\n  font-family: \"MBCorpoSTitle-Regular\";\n  font-size: 20px;\n  line-height: 1.25rem;\n  letter-spacing: 0.0125em;\n  color: black;\n}\n\n.tile:hover {\n  /* background: #494949; */\n  /* border-radius: 2px solid red; */\n}\n\n.tile:hover .tile-text {\n  /* color: #00adef; */\n}\n\n/* .tile:hover .tooltip {\n  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)\n    brightness(120%) contrast(120%);\n} */\n\n.tooltip {\n  filter: brightness(0.2);\n}\n\n.tooltip-icon {\n  width: 25px;\n  margin: 0 2px;\n  cursor: pointer;\n}\n\n.tooltip:hover {\n  filter: brightness(0.5) invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)\n    brightness(120%) contrast(120%);\n}\n\n@media (max-width: 767px) {\n  .landing-page-container {\n    padding: 0 16px;\n    min-height: 75vh;\n  }\n\n  .simple-tooltip {\n    max-width: 240px;\n  }\n\n  .simple-tooltip2 {\n    max-width: 240px;\n  }\n\n  .image-card {\n    width: 60%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .landing-page-container {\n    min-height: 75vh;\n  }\n\n  .image-card {\n    width: 50%;\n  }\n}\n\n@media (max-width: 500px) {\n  .landing-page-container {\n    width: 95vw;\n  }\n\n  .landing-page-grid {\n    flex-direction: column;\n    gap: 50px;\n    width: 100%;\n  }\n\n  .tile {\n    width: 100%;\n  }\n\n  .tile-text {\n    width: auto;\n    word-wrap:break-word;\n  }\n\n  .simple-tooltip {\n    left: 50%;\n    transform: translateX(-82%);\n  }\n\n  .simple-tooltip2 {\n    left: 20%;\n    transform: translate(-75%);\n  }\n}\n\n@media (max-height: 740px) {\n  .landing-page-container {\n    height: 90vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
